import React, { useEffect } from 'react';
import { styled } from '@linaria/react';
const _exp2 = /*#__PURE__*/() => ({
  size
}) => size;
const QrCodeWrapper = /*#__PURE__*/styled('div')({
  name: "QrCodeWrapper",
  class: "q121m1ur",
  propsAsIs: false,
  vars: {
    "q121m1ur-0": [_exp2(), "px"]
  }
});
interface QrCodeProps {
  size?: number;
}
const QR_CODE_ID = 'QRCodeId';
export const QrCode = ({
  size = 145
}: QrCodeProps) => {
  useEffect(() => {
    window.AF_SMART_SCRIPT.displayQrCode(QR_CODE_ID);
  }, []);
  return <QrCodeWrapper id={QR_CODE_ID} size={size} data-id="QRCode"></QrCodeWrapper>;
};

require("./QrCode.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./QrCode.tsx");